/**
* Nom : index.js
* Description : Ce fichier contient la définition de la page index 
*               Cette page intégre les pages de l'application
* Date de création : 23 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, Outlet, RouterProvider, Navigate } from "react-router-dom";
//import { register } from 'react-pwa';

import Login from './pages/login';
import DoubleAuthentication from './pages/doubleAuthentication';
import Menu from './pages/menu';
import { Profile } from 'package_ui_ihm/dist';
import { Help } from 'package_ui_ihm/dist';
import Statistics from './pages/statistics';
import TargetList from './pages/targetList';
import TargetDetails from './pages/targetDetails';
import TargetNew from './pages/targetNew';
import TargetEdit from './pages/targetEdit';
import TargetDelete from './pages/targetDelete';
import TrialList from './pages/trialList';
import TrialDetails from './pages/trialDetails';
import TrialNew from './pages/trialNew';
import TrialEdit from './pages/trialEdit';
import TrialDelete from './pages/trialDelete';
import RdProtocolList from './pages/rdProtocolList';
import CategoryList from './pages/categoryList';
import VarietyList from './pages/varietyList';
import TreatmentTypeList from './pages/treatmentTypeList';
import ATReportList from './pages/atReportList';
import ScientificArticleList from './pages/scientificArticleList';
import ProjectList from './pages/projectList';
import { UserList } from 'package_ui_ihm/dist';
import { UserNew } from 'package_ui_ihm/dist';
import { UserEdit } from 'package_ui_ihm/dist';
import { UserDeactive } from 'package_ui_ihm/dist';
import { UserDelete } from 'package_ui_ihm/dist';
import { UserReactive } from 'package_ui_ihm/dist';
import { UserPasswordEdit } from 'package_ui_ihm/dist';
import CompanyList from './pages/companyList';
import CompanyNew from './pages/companyNew';
import CompanyEdit from './pages/companyEdit';
import { EquipmentList } from 'package_ui_ihm/dist';
import { EquipmentDetails } from 'package_ui_ihm/dist';
import EquipmentNew from './pages/equipmentNew';
import EquipmentSubset from './pages/equipmentSubset';
import PtuTypeRoleList from './pages/ptuTypeRoleList';
import PtuTypeList from './pages/ptuTypeList';
import LedCardTypeList from './pages/ledCardTypeList';
import LedCardList from './pages/ledCardList';
import LedTypeList from './pages/ledTypeList';
import { EquipmentDocumentation } from 'package_ui_ihm/dist';
import DocumentList from './pages/documentList';
import DocumentNew from './pages/documentNew';
import DocumentEdit from './pages/documentEdit';
import DocumentTypeList from './pages/documentTypeList';
import { TreatmentParamList } from 'package_ui_ihm/dist';
import { TreatmentParamDetails } from 'package_ui_ihm/dist';
import TreatmentParamNew from './pages/treatmentParamNew';
import { TreatmentOccurenceList } from 'package_ui_ihm/dist';
import { TreatmentOccurenceDetails } from 'package_ui_ihm/dist';
import { ProtocolList } from 'package_ui_ihm/dist';
import { BatchList } from 'package_ui_ihm/dist';
import { PlanningList} from 'package_ui_ihm/dist';
import { Error } from 'package_ui_ihm/dist';
import { NavBar } from "package_ui_ihm/dist";
import { RgpdPolicy } from "package_ui_ihm/dist";
import reportWebVitals from './reportWebVitals';

/* Hook */
import { AuthProvider, useAuth } from 'package_ui_ihm/dist';
import { ApiProvider } from 'package_ui_ihm/dist';
import { DataProvider } from 'package_ui_ihm/dist';
import { FilterProvider } from 'package_ui_ihm/dist';
import { useEffect } from 'react';


/**
* Router de l'application
*/
const router = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Login />,
            },
            {
                path: "policy",
                element: <RgpdPolicy />,
            },
            {
                path: "double-authent",
                element: <ConfirmationRoute component={DoubleAuthentication} />,
            },
            {
                path: "menu",
                element: <ProtectedRoute component={Menu} />,
            },
            {
                path: "profile",
                element: <ProtectedRoute component={Profile} />,
            },
            {
                path: "help",
                element: <ProtectedRoute component={Help} />,
            },
            {
                path: "statistics",
                element: <ProtectedRoute component={Statistics} />,
            },
            {
                path: "targets",
                element: <ProtectedRoute component={TargetList} />,
            },
            {
                path: "targets/:id",
                element: <ProtectedRoute component={TargetDetails} />,
            },
            {
                path: "targets/new",
                element: <ProtectedRoute component={TargetNew} />,
            },
            {
                path: "targets/:id/edit",
                element: <ProtectedRoute component={TargetEdit} />,
            },
            {
                path: "targets/:id/delete",
                element: <ProtectedRoute component={TargetDelete} />,
            },
            {
                path: "trials",
                element: <ProtectedRoute component={TrialList} />,
            },
            {
                path: "trials/:catId/:varId/:typeId",
                element: <ProtectedRoute component={TrialList} />,
            },
            {
                path: "trials/:id",
                element: <ProtectedRoute component={TrialDetails} />,
            },
            {
                path: "trials/new",
                element: <ProtectedRoute component={TrialNew} />,
            },
            {
                path: "trials/new/:targetId",
                element: <ProtectedRoute component={TrialNew} />,
            },
            {
                path: "trials/:id/edit",
                element: <ProtectedRoute component={TrialEdit} />,
            },
            {
                path: "trials/:id/delete",
                element: <ProtectedRoute component={TrialDelete} />,
            },
            {
                path: "rd-protocols",
                element: <ProtectedRoute component={RdProtocolList} />,
            },
            {
                path: "categories",
                element: <ProtectedRoute component={CategoryList} />,
            },
            {
                path: "varieties",
                element: <ProtectedRoute component={VarietyList} />,
            },
            {
                path: "treatment-types",
                element: <ProtectedRoute component={TreatmentTypeList} />,
            },
            {
                path: "at-reports",
                element: <ProtectedRoute component={ATReportList} />,
            },
            {
                path: "scientific-articles",
                element: <ProtectedRoute component={ScientificArticleList} />,
            },
            {
                path: "ptu-type-roles",
                element: <ProtectedRoute component={PtuTypeRoleList} />,
            },
            {
                path: "projects",
                element: <ProtectedRoute component={ProjectList} />,
            },
            {
                path: "equipments",
                element: <ProtectedRoute component={EquipmentList} />,
            },
            {
                path: "equipments/:id",
                element: <ProtectedRoute component={EquipmentDetails} />,
            },
            {
                path: "equipments/new",
                element: <ProtectedRoute component={EquipmentNew} />,
            },
            {
                path: "equipments/subset",
                element: <ProtectedRoute component={EquipmentSubset} />,
            },
            {
                path: "equipments/ptuType",
                element: <ProtectedRoute component={PtuTypeList} />,
            },
            {
                path: "equipments/ledCardType",
                element: <ProtectedRoute component={LedCardTypeList} />,
            },
            {
                path: "equipments/ledCard",
                element: <ProtectedRoute component={LedCardList} />,
            },
            {
                path: "equipments/ledType",
                element: <ProtectedRoute component={LedTypeList} />,
            },
            {
                path: "equipments/:id/documentation",
                element: <ProtectedRoute component={EquipmentDocumentation} />,
            },
            {
                path: "documents",
                element: <ProtectedRoute component={DocumentList} />,
            },
            {
                path: "documents/new",
                element: <ProtectedRoute component={DocumentNew} />,
            },
            {
                path: "documents/:id/edit",
                element: <ProtectedRoute component={DocumentEdit} />,
            },
            {
                path: "document-types",
                element: <ProtectedRoute component={DocumentTypeList} />,
            },
            {
                path: "protocols",
                element: <ProtectedRoute component={ProtocolList} />,
            },
            {
                path: "batches",
                element: <ProtectedRoute component={BatchList} />,
            },
            {
                path: "plannings",
                element: <ProtectedRoute component={PlanningList} />,
            },
            {
                path: "users",
                element: <ProtectedRoute component={UserList} />,
            },
            {
                path: "users/new",
                element: <ProtectedRoute component={UserNew} />,
            },
            {
                path: "users/:id/edit",
                element: <ProtectedRoute component={UserEdit} />,
            },
            {
                path: "users/:id/deactive",
                element: <ProtectedRoute component={UserDeactive} />,
            },
            {
                path: "users/:id/delete",
                element: <ProtectedRoute component={UserDelete} />,
            },
            {
                path: "users/:id/reactive",
                element: <ProtectedRoute component={UserReactive} />,
            },
            {
                path: "password-edit",
                element: <ProtectedRoute component={UserPasswordEdit} />,
            },
            {
                path: "companies",
                element: <ProtectedRoute component={CompanyList} />,
            },
            {
                path: "companies/new",
                element: <ProtectedRoute component={CompanyNew} />,
            },
            {
                path: "companies/:id/edit",
                element: <ProtectedRoute component={CompanyEdit} />,
            },
            {
                path: "treatment-params/:equipmentId",
                element: <ProtectedRoute component={TreatmentParamList} />,
            },
            {
                path: "treatment-params/detail/:equipmentId/:id",
                element: <ProtectedRoute component={TreatmentParamDetails} />,
            },
            {
                path: "treatment-params/new/:equipmentId",
                element: <ProtectedRoute component={TreatmentParamNew} />,
            },
            {
                path: "treatment-occurences/:equipmentId/:treatmentParamId",
                element: <ProtectedRoute component={TreatmentOccurenceList} />,
            },
            {
                path: "treatment-occurences/detail/:equipmentId/:treatmentParamId/:id",
                element: <ProtectedRoute component={TreatmentOccurenceDetails} />,
            },
            {
                path: "*",
                element: <Error />
            }
        ],
    },

    // tes autres routes ici
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ApiProvider>
        <DataProvider>
          <FilterProvider>
            <RouterProvider router={router} />
          </FilterProvider>
        </DataProvider>
      </ApiProvider>
    </AuthProvider>
  </React.StrictMode>
);


/**
* ConfirmationRoute : permet la navigation vers la page si l'utilisateur est connecté (avant vérification de la double authentification)
*                     sinon renvoi la page login
*
* Type : page 
*
* Parametres : 
*  None
*/
function ConfirmationRoute({ component: Component }) {
  const { authStatus } = useAuth();

  useEffect(() => {
    console.log("Auth status has changed, current status:", authStatus);
  }, [authStatus]);

  return (authStatus === 200) ? <Component /> : <Navigate to="/" replace />;
}

/**
* ConfirmationRoute : permet la navigation vers la page si l'utilisateur est connecté et sa double authentification est validée 
*                     sinon renvoi la page login
*
* Type : page 
*
* Parametres : 
*  None
*/
function ProtectedRoute({ component: Component }) {
  const { authStatus, authConfirm } = useAuth();

  useEffect(() => {
    console.log("User authentication is confirmed", authConfirm);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authConfirm]);

  return (authStatus === 200 && authConfirm === true) ? <Component /> : <Navigate to="/" replace />;
}

function Layout() {
    return (
        <>
            <NavBar name_app="BOXIBRAIN" />
            <Outlet />
        </>
    );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA
//register();
 